/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {useState} from 'react';
import {Carousel, Image, Spinner} from 'react-bootstrap';
import makeAnimated from 'react-select/animated';

import "../../CSS/DataModal.css";
import "react-datepicker/dist/react-datepicker.css";
import CommonModal from "../CommonModal/CommonModal";
import PropTypes from "prop-types";

const animatedComponents = makeAnimated();

function InstallPicsModal({show, onClick, picList, loading}) {
    const [index, setIndex] = useState(0);
    const [imageClicked, setImageClicked] = useState(false);
    const [currentImageItem, setCurrentImageItem] = useState(null);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };
    
    const onCloseClick = () => {
        setIndex(0);
        setImageClicked(false);
        setCurrentImageItem(null);
        onClick();
    }
    
    const imageClick = (item) => {
        if (item !== currentImageItem) {
            setImageClicked(true);
            setCurrentImageItem(item);
        }
        else {
            setImageClicked(false);
            setCurrentImageItem(null);
        }
    }
    
    let modalContent = picList !== null && picList !== undefined && picList.length ?
        (imageClicked && currentImageItem !== null ? 
            <div>
                <Image src={currentImageItem.data === null || currentImageItem.data === undefined ? require("../../img/NoImage2.png") : "data:image/png;base64," + currentImageItem.data} fluid onClick={() => imageClick(currentImageItem)} />
            </div>
            : <div>
                <Carousel activeIndex={index} onSelect={handleSelect} interval={null}>
                    {picList.map((item, index) =>
                        <Carousel.Item key={index}>
                            <Image src={item.data === null || item.data === undefined ? require("../../img/NoImage2.png") : "data:image/png;base64," + item.data} className={"box-40h-20p"} onClick={() => imageClick(item)}/>
                        </Carousel.Item>
                    )}
                </Carousel>
            </div>
        )
        : <div>
            No Install Images for this customer.
        </div>;

    if (show) {
        return (
            <div>
                <CommonModal show={show} onYes={onCloseClick} onClick={onCloseClick} content={modalContent} title={'Installation Pictures'} loading={loading}/>
            </div>
        )
    }
    else {
        return null;
    }
}

InstallPicsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    picList: PropTypes.array.isRequired
};

export default InstallPicsModal;